import React, { useEffect } from "react";
import "./Chat.css";
import { clearCallbackHash } from "../../../services/sso/SSOCallbackHandler";

export default function Chat() {
  const CHAT_URL = process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_CHAT_URL_PROD
    : process.env.REACT_APP_CHAT_URL_DEV;

  useEffect(() => {
    clearCallbackHash();
  }, []);

  return (
    <div className="chat-root">
      <iframe
        id="owly-chat-iframe"
        src={`${CHAT_URL}?isOpen=true&isMaximized=true`}
        title="Owly Chat"
        className="chat-root-iframe"
        allow="clipboard-write; clipboard-read; microphone; camera"
      />
    </div>
  );
}

